/**
 * Question identifiers and answer values of the meeting questionnaires.
 *
 * They mirror App\Service\Meeting\MeetingQuestions on the API side: the form is
 * fixed per meeting type, so both ends agree on these keys instead of the API
 * describing the form.
 */
const QUESTIONS = {
  COD_FRT_PARTICIPATION: 'COD_FRT_PARTICIPATION',
  COD_PARTICIPATION: 'COD_PARTICIPATION',
  COD_ABSENCE: 'COD_ABSENCE',
  COD_VOTING: 'COD_VOTING',
  CSP_PARTICIPATION: 'CSP_PARTICIPATION',
  DINNER_PARTICIPATION: 'DINNER_PARTICIPATION',
  DINNER_PLUS_ONE: 'DINNER_PLUS_ONE',

  ABSENCE_SUBSTITUTE: 'SUBSTITUTE',
  ABSENCE_PROXY: 'PROXY',

  VOTING_SELF: 'SELF',
  VOTING_REPRESENTATIVE: 'REPRESENTATIVE',
  VOTING_PROXY: 'PROXY',
};

export default QUESTIONS;
